import { Product } from '../../lib/types/models/product/product'
import { ProductInput } from '../../lib/types/models/product/product-input'

export const mapProductToInput = (product: Product): ProductInput => {
  const { id: _id, country, formula, ...rest } = product

  return {
    ...rest,
    countryId: country?.id,
    formulaId: formula?.id
  }
}
